import { ReactElement } from 'react'

import { CancelDepositInvoiceEligibility } from '../../types/invoiceDeposit/cancelDepositInvoiceEligibility'
import { BlockCancelInvoiceActionModal } from '../BlockCancelInvoiceActionModal'
import { BlockCancelInvoiceActionVariant } from '../BlockCancelInvoiceActionModal/enums/blockCancelInvoiceActionVariant'

interface BlockCancelInvoiceActionModalsProps {
  cancelDepositInvoiceEligibility: CancelDepositInvoiceEligibility
  invoiceId: string
}

export const BlockCancelInvoiceActionModals = ({
  cancelDepositInvoiceEligibility,
  invoiceId,
}: BlockCancelInvoiceActionModalsProps): ReactElement | null => {
  if (!cancelDepositInvoiceEligibility.isCancelBlockedByFinalInvoice) {
    return null
  }

  return (
    <>
      <BlockCancelInvoiceActionModal
        invoiceId={invoiceId}
        relatedFinalInvoice={cancelDepositInvoiceEligibility.relatedFinalInvoice}
        variant={BlockCancelInvoiceActionVariant.CreditNote}
      />
      <BlockCancelInvoiceActionModal
        invoiceId={invoiceId}
        relatedFinalInvoice={cancelDepositInvoiceEligibility.relatedFinalInvoice}
        variant={BlockCancelInvoiceActionVariant.Void}
      />
    </>
  )
}
